<template>
  <v-sheet>
    <v-card class="text-center my-0 pa-0" flat>
      <v-card flat class="text-center my-0 pa-0">
        <v-card-title class="pa-0 mb-0 mx-0 subtitle-2">
          <v-spacer></v-spacer>
          <v-card outlined :class="dense ? 'mx-1' : 'mx-2'">
            <v-list
              dense
              :width="kachelbreite"
              :class="[currentBbr === bbr.id ? 'grey lighten-2' : '', dense ? 'pa-0' : '']"
            >
              <v-list-item class="px-1">
                <v-list-item-content class="text-truncate py-1">
                  <v-list-item-title>
                    <span v-if="bbr.titel" class="pr-1">{{ bbr.titel }}</span> {{ bbr.nachname }}, {{ bbr.vorname }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    rec. {{ $filters.date(bbr.receptionsdatum, "DD.MM.YYYY") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <v-spacer></v-spacer>
        </v-card-title>
      </v-card>
      <svg id="svg" width="100%" :height="svgHeight" class="pa-0 ma-0" v-if="sohn.length > 0">
        <g v-if="kanten.length > 0">
          <path
            v-for="(item, index) in kanten"
            :key="index"
            :d="
              'M' +
              item.x1 +
              ' ' +
              item.y1 +
              ' C ' +
              item.x1 +
              ' ' +
              item.y2 +
              ' ' +
              item.x2 +
              ' ' +
              item.y1 +
              ' ' +
              item.x2 +
              ' ' +
              item.y2 +
              ''
            "
            stroke="lightgrey"
            stroke-width="1"
            fill="none"
          />
        </g>
      </svg>
      <v-card class="d-flex justify-center ma-0" flat v-if="sohn.length > 0">
        <stammbaumKnoten
          class="mt-n2"
          v-for="(node, index) in sohn"
          :key="index"
          :sohn="node.sohn"
          :bbr="node.bbr"
          :blatter="node.blatter"
          :ebene="ebene + 1"
          :currentBbr="currentBbr"
          :dense="dense"
          :kachelbreite="kachelbreite"
        >
        </stammbaumKnoten>
      </v-card>
    </v-card>
  </v-sheet>
</template>

<script>
  import stammbaumKnoten from "@/module/submodule/stammbaumKnoten";
  export default {
    components: {
      stammbaumKnoten,
    },
    props: ["bbr", "sohn", "blatter", "ebene", "currentBbr", "dense", "kachelbreite"],
    name: "stammbaumKnoten",
    data() {
      return {
        date: "",
      };
    },
    computed: {
      svgHeight() {
        return this.dense ? 20 : 32;
      },
      kanten() {
        let kanten = [];
        let breite = this.blatter * 2;
        let curBreite = 0;
        let abstand = this.dense ? 10 : 18;
        this.sohn.forEach((item) => {
          curBreite += item.blatter;
          kanten.push({
            x1: (this.blatter * (this.kachelbreite + abstand)) / 2,
            y1: 0,
            x2: ((this.blatter * (this.kachelbreite + abstand)) / breite) * curBreite,
            y2: this.svgHeight,
          });
          curBreite += item.blatter;
        });
        return kanten;
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// stammbaumKnoten.vue?0b5bbc90